<template>
  <div>
    <el-dialog
      :visible.sync="viewDialogVisible"
      :show-close="false"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      class="return-detail"
    >
      <div slot="title" class="dialog-title dialog-top">
        <div class="dialog-detail">
          <span class="detail">{{ $lang('退回申请失败') }}</span>
        </div>
        <img class="dialog-close" src="@/assets/images/close.png" alt="" @click="viewDialogVisible = false" />
      </div>
      <div class="dialog-center">
        <el-table height="250" ref="singleTable" :data="tableData" border style="width: 100%">
          <el-table-column property="waybillNo" :label="$t('单号')" width="200"> </el-table-column>
          <el-table-column property="reason" :label="$t('失败原因')"> </el-table-column>
        </el-table>
      </div>
      <div class="dialog-footer">
        <el-button @click="viewDialogVisible = false" class="h40">{{ $lang('确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Detail',
  props: {
    rowData: {
      type: Object,
      default: _ => {
        return {}
      },
    },
  },
  data () {
    return {
      viewDialogVisible: false,
      tableData: []
    }
  },
  methods: {
    showDialog (data) {
      this.viewDialogVisible = true
      this.tableData = data
    }
  },
}
</script>
<style lang="scss" scoped>
.dialog-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .dialog-detail {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .detail {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFangSC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      font-weight: 600;
    }
    i {
      display: inline-block;
      border-radius: 50%;
      overflow: hidden;
      width: 8px;
      height: 8px;
      background: #fa8b14;
      margin-left: 16px;
      margin-right: 8px;
    }
  }
  .dialog-close {
    width: 16px;
    height: 16px;
    display: inline-block;
    cursor: pointer;
  }
}
.dialog-center {
  padding-right: 25px;
  height: 300px;
}
.search-form {
  ::v-deep .el-table {
    .el-input {
      width: 100% !important;
    }
  }
}
</style>
<style lang="scss">
.el-dialog__wrapper.return-detail {
  .el-dialog {
    margin-bottom: 0 !important;
    .el-dialog__body {
      max-height: 600px;
      overflow: auto;
    }
  }
  .el-dialog__footer {
    padding: 0;
    margin: 10px 20px 20px;
  }
}
</style>
